/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */
import { Component, Input } from '@angular/core';

@Component({
    selector: '[uiSpinner]',
    template: require('./ui-spinner.html'),
    styles: [require('./ui-spinner.less')],
})
export class UiTableSpinner {
    private state;

    @Input('uiSpinner')
    public set uiSpinner(state: boolean) {
        this.state = state;
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/ui-table-spinner/ui-spinner.ts